module.exports = __webpack_public_path__ + "img/0.29c56754.png";